// extracted by mini-css-extract-plugin
module.exports = {"about":"about-module--about--1wsIb","imgContainer":"about-module--imgContainer--2w-wu","link":"about-module--link--2ouvq"};